module.exports = __webpack_public_path__ + "img/tabbar-game.98561836.png";